import { gql } from '@apollo/client';

export const FIND_LOCAL_AREA = gql`
query findLocalArea($input: FindLocalAreaInput!){
  findLocalArea(input: $input) {
    distance
    metricType
    placeId
    address
    location {
      lat
      lng
    }
    localArea
  }
}`;
